// https://www.kunkalabs.com/mixitup/docs/get-started/
import mixitup from 'mixitup';

$(document).ready(function() {
    var initialFilter = 'all';
    var hash = window.location.hash.replace(/^#/g, '');
    if (hash) {
        initialFilter = '.' + hash;
    }

    if ($('.mixit--filter').length) {
        var mixer = mixitup(".mixit--filter", {
            animation: {
                animateResizeTargets: true,
                duration: 550,
                nudge: true,
                reverseOut: false,
                effects: "fade scale(0.01) translateZ(-100px)"
            },
            selectors: {
                control: '.mixitup-control'
            },
            load: {
                filter: initialFilter
            }
        });
    }
    if ($('.mixit--filter--products').length) {
        var showfirstID = $('.filter--wrapper--products').children().find(">:first-child").attr('data-filter');
       
        var mixer = mixitup(".mixit--filter--products", {
            animation: {
                enable: false

            },
            selectors: {
                control: '.mixitup-control'
            },
            load: {
                filter: showfirstID
            }
        });
    }
});
